<div class="service-personel-container">
  <div class="row mr-0">
    <div class="header col-md-12">
      <div class="row mr-0">
        <div class="header col-md-10">
          <div class="title">{{'servicePersonnel.servicePersonnel'| translate}}</div>
          <div class="warning-msg" *ngIf="(activeAdvisors$ | async)?.length < 1 && !(isLoading$ | async) ">
            <div><span class="material-icons" >info</span></div>
            <div>{{'navigation.pleaseMakeServiceAdvisorsOnline' | translate }}</div>
        </div>
        </div>
        <div class='action col-md-2' style="text-align: left;">
          <div *ngIf="(isSyncStatusLoading$|async); else updateBtn">
            <app-loading class="staff-master-sync-loading"
                         loadingSymbol="dots"
                         [text]="'servicePersonnel.loadingSyncStatus' | translate"
                         size=".8"
                         color="var(--dashboard-primary-color)">
            </app-loading>
          </div>
          <ng-template #updateBtn>
            <button class='refresh' (click)='triggerStaffMasterSync()'
                  [disabled]="(syncStatus$ | async) === 'SYNC_IN_PROGRESS'"
                  [ngClass]="(syncStatus$ | async) === 'SYNC_IN_PROGRESS' ? 'disabled': ''">
            <ng-container *ngIf="(syncStatus$ | async) === 'SYNC_IN_PROGRESS'; else serviceSyncLabel">
              <app-loading loadingSymbol="dots" [text]="'servicePersonnel.syncInProgress' | translate" color="var(--primary-toyota-color)" size=".55" [compact]="true"></app-loading>
            </ng-container>
            <ng-template #serviceSyncLabel>
              <asp-icon class="icon" name="ic-20-utility-update-small.svg" width="1.2rem" height='1.2rem' color='var(--primary-toyota-color)'>
              </asp-icon>
              <span>{{'servicePersonnel.updateFromStaffMaster'| translate}}</span>
            </ng-template>
          </button>
          <div class="sync-text">
            <asp-icon class="icon d-inline-block" name="ic-20-utility-time-clock.svg" width="1.2rem" height='1.2rem'
                      color='var(--primary-toyota-color)'>
            </asp-icon>
            <span>{{(lastSyncedAt$ | async) || '' }}</span>
          </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>

  <div class='service-selector'>
    <div class='service-view col-6' [ngClass]="viewMode == 'advisors' ? 'selected':''" (click)="viewMode ='advisors'">{{'servicePersonnel.serviceadvisors'| translate}}</div>
    <div class='service-view col-6' [ngClass]="viewMode == 'technicians' ? 'selected':''" (click)="viewMode ='technicians'">
      {{'servicePersonnel.serviceTechnicians'| translate}}</div>
  </div>

  <ng-container *ngIf="viewMode == 'advisors'">
    <div class="row mr-0">
      <div class="col-md-12 list-header">
       {{'servicePersonnel.onlineAdvisors'| translate}}({{(activeAdvisors$ | async)?.length}})
      </div>
    </div>
    <div class="row mr-0">
      <div class="col-md-12">
        <app-employee-list [employees]="(activeAdvisors$ | async)"></app-employee-list>
      </div>
    </div>

    <div class="row mr-0">
      <div class="col-md-12 list-header">
       {{'servicePersonnel.offlineAdvisors'| translate}} ({{(inActiveAdvisors$ | async)?.length}})
      </div>
    </div>
    <div class="row mr-0">
      <div class="col-md-12">
        <app-employee-list [employees]="(inActiveAdvisors$ | async)"></app-employee-list>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="viewMode == 'technicians'">
    <div class="list-header">
      {{'servicePersonnel.onlineTechnicians'| translate}}  ({{(activeTechnicians$ | async)?.length}})
    </div>
    <app-employee-list [employees]="(activeTechnicians$ | async)"></app-employee-list>
    <div class="list-header">
      {{'servicePersonnel.offlineTechnicians'| translate}}  ({{(inActiveTechnicians$ | async)?.length}})
    </div>
    <app-employee-list [employees]="(inActiveTechnicians$ | async)"></app-employee-list>
  </ng-container>

</div>
